@import "../offsites-widget-v4/widget-component/offsites-widget-v4.scss";

@keyframes skeletonMove {
  0% {
    background-position: -200px 0;
  }

  100% {
    background-position: calc(200px + 100%) 0;
  }
}

.search-skeleton__wrapper {
  width: 100%;
  display: flex;
  margin: 8px 0 20px;
  @media (max-width: $uiaas-tablet) {
    margin-top: 20px;
  }
}

.search-skeleton__block {
  display: flex;
  width: 100%;
  height: 300px;

  @media (max-width: $uiaas-tablet) {
    flex-direction: column;
    height: auto;
  }
}

.search-skeleton-container {
  background-color: white;
  padding: 20px;
  flex-grow: 1;

  @media (max-width: $uiaas-tablet) {
    order: 1;
  }
}

.search-skeleton {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.search-skeleton__image-placeholder {
  height: 100%;
  background-color: #e9e9e9;
  width: 50%;
  @media (max-width: $uiaas-tablet) {
    width: 100%;
    height: 153px;
  }
}

.search-skeleton__item {
  background-color: #e6e6e6;
  background-image: linear-gradient(
    90deg,
    rgb(230, 230, 230),
    rgb(247, 247, 247),
    rgb(230, 230, 230)
  );
  animation: skeletonMove 1.2s ease-in-out infinite;
  background-size: 200px 100%;
  background-repeat: no-repeat;
  border-radius: 2px;
  display: inline-block;
  width: 100%;
  margin: 4px 0;
  height: 60px;
}

.search-skeleton__item:last-child {
  width: 191px;
  height: 40px;
  margin-top: 12px;
}

.offsite-banner-list-element {
  margin: 15px 0;
}
